import Vue from 'vue'
import VueRouter from "vue-router";

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new VueRouter({
    mode: 'history',

    //切换页面回到顶部
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0}
    },
    routes: [
        {
            path: "/",
            redirect: "/index"
        },
        {
            path: '/Home',
            component: () =>
                import ('../view'),
            children: [
                {
                    path: '/index',
                    component: () =>
                        import ("../view/Home.vue"),
                    meta: {title: "首页", keepAlive: false}
                },
                {
                    path: '/user',
                    component: () =>
                        import ("../view/user.vue"),
                    meta: {title: "人才信息查询", keepAlive: false}
                },
                {
                    path: '/firm',
                    component: () =>
                        import ("../view/firm.vue"),
                    meta: {title: "企业信息查询", keepAlive: false}
                },
                {
                    path: '/grjg',
                    component: () =>
                        import ("../view/result.vue"),
                    meta: {title: "证书查询结果", keepAlive: false}
                },
                {
                    path: '/qyjg',
                    component: () =>
                        import ("../view/resultCompany.vue"),
                    meta: {title: "企业查询结果", keepAlive: false}
                },
                {
                    path: '/qyry',
                    component: () =>
                        import ("../view/resultHonor.vue"),
                    meta: {title: "企业荣誉查询结果", keepAlive: false}
                },
                {
                    path: '/qyhy',
                    component: () =>
                        import ("../view/resultMember.vue"),
                    meta: {title: "企业会员查询结果", keepAlive: false}
                },
            ]
        }
    ]
})
